/**
 * Страница с рабочим графиком сотрудника
 */
import { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { ScheduleCalendar } from '../components/ScheduleCalendar'
import { BottomNav } from '../components/BottomNav'
import './SchedulePage.css'

type NavTab = 'qr' | 'sites' | 'schedule' | 'profile'

export function SchedulePage() {
  const navigate = useNavigate()
  const [activeTab] = useState<NavTab>('schedule')

  const handleTabChange = (tab: NavTab) => {
    if (tab === 'qr') {
      navigate('/')
    } else if (tab === 'profile') {
      navigate('/profile')
    } else if (tab === 'sites') {
      navigate('/sites')
    }
    // schedule - уже на этой странице
  }

  return (
    <div className="schedule-page">
      <div className="schedule-page__header">
        <h1 className="schedule-page__title">📅 Рабочий график</h1>
        <p className="schedule-page__subtitle">Ваш график работы на месяц</p>
      </div>

      <div className="schedule-page__content">
        <ScheduleCalendar />
      </div>

      <BottomNav activeTab={activeTab} onTabChange={handleTabChange} />
    </div>
  )
}
